module.exports = __webpack_public_path__ + "media/images/sp/stores/funabashi/access/logo-a31dcb6b5941db21d8ce821a19b92bb9.svg";